import { TestOptionType, useABTesting } from '@dh-io-emh/shared/src/composables/ab-testing.composable';
import { IProductFilterGroup } from '@dh-io-emh/shared/src/models/product-filter/product-filter-base.model';
import { FilterContainerCode } from '@dh-io-emh/shared/src/models/product-filter/product-filter-base.model';
import { computed, Ref } from 'vue';

export const useAvailabilityFilter = (filterCategories: Ref<IProductFilterGroup[]>) => {
  const abTestingAvailability = useABTesting('AvailabilityCategory');

  const availabilityFilter = computed(() =>
    filterCategories.value.find(({ code }) => code === FilterContainerCode.stockType),
  );

  const filteredSideFilters = computed(() => {
    // This is done to separate the rest of the sideFilters from the availability filter,
    // because the availability filter has been taken out the sideFilters and moved above
    if (abTestingAvailability.target.value === TestOptionType.TARGET) {
      return filterCategories.value.filter(({ code }) => code !== FilterContainerCode.stockType);
    }

    return filterCategories.value;
  });

  return {
    availabilityFilter,
    filteredSideFilters,
  };
};
